import { render, staticRenderFns } from "./CreateContentFolderModal.vue?vue&type=template&id=46585cdb&scoped=true"
import script from "./CreateContentFolderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateContentFolderModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateContentFolderModal.vue?vue&type=style&index=0&id=46585cdb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46585cdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46585cdb')) {
      api.createRecord('46585cdb', component.options)
    } else {
      api.reload('46585cdb', component.options)
    }
    module.hot.accept("./CreateContentFolderModal.vue?vue&type=template&id=46585cdb&scoped=true", function () {
      api.rerender('46585cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CreateContentFolderModal/CreateContentFolderModal.vue"
export default component.exports